module.exports = __webpack_public_path__ + "static/media/fondo-slider-1.74697f50.jpg";